CKEDITOR.editorConfig = (config) ->
  # Define changes to default configuration here.
  # For complete reference see:
  # http://docs.ckeditor.com/#!/api/CKEDITOR.config
  # The toolbar groups arrangement, optimized for two toolbar rows.
  config.toolbarGroups = []
  # Remove some buttons provided by the standard plugins, which are
  # not needed in the Standard(s) toolbar.
  # Set the most common block elements.
  config.format_tags = 'p;h1;h2;h3;h4;h5;h6'
  # Simplify the dialog windows.
  config.removeDialogTabs = 'image:advanced;link:advanced'

  return



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/ckeditor_config.coffee